import { handlePrintModal } from '../../utils/SiteHelpers';
import { Download, Email, Print } from '@mui/icons-material';
import PDFViewer from '../../components/reusable/PDFViewer';
import { useCourses } from '../../context/CourseContext';
import { Box } from '@mui/material';
import Modal from '../../components/reusable/modal/Modal';

const PreviewCertificateModal = ({ open, setOpen, pdfUrl, courseId }) => {
    const { downloadCertificate, emailCertificate } = useCourses();

    return (
        <Box>
            <Modal
                size="sm"
                handleClose={() => {
                    setOpen(false);
                }}
                show={open}
                title="Certificate"
                modalBody={
                    <PDFViewer
                        fileUrl={pdfUrl}
                        height={'70vh'}
                        width={'100%'}
                    />
                }
                headerBtns={[
                    {
                        index: 1,
                        buttonName: 'download',
                        onClickEvent: () => {
                            downloadCertificate(courseId);
                        },
                        icon: <Download fontSize="small" sx={{ mr: 1 }} />,
                    },
                    {
                        index: 2,
                        buttonName: 'email',
                        onClickEvent: () => emailCertificate(courseId),
                        icon: <Email fontSize="small" sx={{ mr: 1 }} />,
                    },
                    {
                        index: 3,
                        buttonName: 'print',
                        onClickEvent: () => {
                            handlePrintModal(pdfUrl);
                        },
                        icon: <Print fontSize="small" sx={{ mr: 1 }} />,
                    },
                ]}
            />
        </Box>
    );
};

export default PreviewCertificateModal;
